import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import FixedTooltipPortal from 'dpl/common/tooltip/components/FixedTooltipPortal';

import useSearchFiltering from '../hooks/useSearchFiltering';
import SearchFilters from './SearchFilters';
import MobileFilterButtons from './MobileFilterButtons';

export default function MobileFilterMenu({ totalItemCount }) {
  const { isFiltersModalOpen, toggleFilters, resultsType } =
    useSearchFiltering();

  return (
    <FixedTooltipPortal
      className="MobileFilterMenu"
      isVisible={isFiltersModalOpen}
      onCloseClick={toggleFilters}
      wrapperClassName={classnames({ 'top-1': isFiltersModalOpen })}
      style={{ paddingBottom: 0, maxHeight: '100%' }}
    >
      <p className="font-20 font-serif fw-medium bb b--default pt3 pb5 mb6">
        Filter Results ({totalItemCount})
      </p>
      <SearchFilters className="pb8" />

      <MobileFilterButtons
        className="sticky bottom-0 bg-white pv6"
        setIsMenuOpen={toggleFilters}
        totalItemCount={totalItemCount}
        resultsType={resultsType}
      />
    </FixedTooltipPortal>
  );
}

MobileFilterMenu.propTypes = {
  totalItemCount: PropTypes.number.isRequired
};
